// Public interface for PDF document - only exports tested methods

import type { NewDocument } from "./NewDocument"

export type PDFDocument = {
  readonly error?: string
  ensure_page_available(page: number): Promise<number>
  iterate_pages(): AsyncGenerator<number>
  render_page_to_imagedata(
    page: number,
    options?: { scale: number, max_size?: number }
  ): Promise<{
    blob: Blob
    size: number[]
  }>
  extract_page_as_pdf(page: number): Promise<{
    blob: Blob
    trim_box: number[]
    media_box: number[]
  }>
  copy(): Promise<NewDocument>
  copy_page_to(
    target: NewDocument,
    page_ranges?: [number, number][],
    insert_at?: number
  ): Promise<NewDocument>
} & NewDocument
